import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text, Textarea, useMultiStyleConfig} from '@chakra-ui/react'

const TextAreaComponent = React.forwardRef((props, ref) => {
    const {isInvalid, rules, placeholder, onBlur, textAreaMaxLength, ...rest} = props

    let status = undefined
    status ??= isInvalid && 'invalid'

    const styles = useMultiStyleConfig('Field', {variant: status})
    const characterCount = props.value.length
    return (
        <Box __css={styles.container}>
            <Textarea
                placeholder={`${placeholder}${rules?.required ? ' *' : ''}`}
                {...rest}
                ref={ref}
                onBlur={onBlur}
                maxLength={textAreaMaxLength}
                sx={{
                    ...styles.textArea,
                }}
            />
            <Text {...styles.counter}>
                {characterCount}
                {textAreaMaxLength && `/${textAreaMaxLength}`}
            </Text>
        </Box>
    )
})

TextAreaComponent.displayName = 'TextAreaComponent'
TextAreaComponent.propTypes = {
    inputProps: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    isDisabled: PropTypes.bool,
    isInvalid: PropTypes.bool,
    tooltip: PropTypes.string,
    value: PropTypes.string,
    isSuccess: PropTypes.bool,
    isRequired: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    placeholder: PropTypes.string,
    variant: PropTypes.string,
    sx: PropTypes.object,
    ariaLabel: PropTypes.string,
    rules: PropTypes.object,
    textAreaMaxLength: PropTypes.string,
}

export default TextAreaComponent
